import { render, staticRenderFns } from "./tempLinks.vue?vue&type=template&id=f1076dca&scoped=true"
import script from "./tempLinks.vue?vue&type=script&lang=js"
export * from "./tempLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1076dca",
  null
  
)

export default component.exports